import { createStore, applyMiddleware } from 'redux';
import { combineReducers } from 'redux-immutable';

import user from '~/reducers/user';
import cookie from '~/reducers/cookie';
import translations from '~/reducers/translations';
import snackbar from '~/reducers/snackbar';
import confirmation from '~/reducers/confirmation';
import customersNew from '~/reducers/customersNew';
import orders from '~/reducers/orders';
import products from '~/reducers/products';
import articles from '~/reducers/articles';
import locations from '~/reducers/locations';
import actions from '~/reducers/actions';
import work from '~/reducers/work';
import kits from '~/reducers/kits';
import dashboards from '~/reducers/dashboards';
import customerGroups from '~/reducers/customerGroups';
import boxStats from '~/reducers/boxStats';
import logs from '~/reducers/logs';
import heartbeat from '~/reducers/heartbeat';
import rawMaterial from '~/reducers/rawMaterial';
import recipe from '~/reducers/recipe';
import containers from '~/reducers/containers';
import tasks from '~/reducers/tasks';
import stock from '~/reducers/stock';
import rawMaterialStock from '~/reducers/rawMaterialStock';
import transactions from '~/reducers/transactions';
import orderNew from '~/reducers/orderNew';
import customers from '~/reducers/customers';
import eshop from '~/reducers/eshop';
import bundles from '~/reducers/bundles';

const reducers = combineReducers({
  user,
  boxStats,
  cookie,
  translations,
  snackbar,
  confirmation,
  orders,
  products,
  articles,
  locations,
  actions,
  work,
  dashboards,
  kits,
  logs,
  heartbeat,
  customerGroups,
  customersNew,
  rawMaterial,
  recipe,
  containers,
  tasks,
  stock,
  rawMaterialStock,
  transactions,
  orderNew,
  customers,
  eshop,
  bundles
});

const logger = store => next => action => {
  const res = next(action);
  if (process.env.NODE_ENV !== 'production') {
    const stateOld = store;
    console.info(
      // eslint-disable-line
      'Action dispatched',
      action,
      'old state:',
      stateOld.getState().toJS(),
      'next state:',
      store.getState().toJS()
    );
  }
  return res;
};

export default function (initialState) {
  return createStore(reducers, initialState, applyMiddleware(logger));
}



// WEBPACK FOOTER //
// ./app/store.js